export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3 select-none">
      <svg width="36" height="36" viewBox="0 0 64 64" aria-hidden="true" className="shrink-0">
        <rect width="64" height="64" rx="14" fill="#0F1015" />
        <rect x="1.5" y="1.5" width="61" height="61" rx="12.5" fill="none" stroke="#D4AF37" strokeOpacity="0.55" strokeWidth="2" />
        <path d="M16 46V20l16 16 16-16v26" fill="none" stroke="#E6CA65" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="leading-none">
        <span className="block font-display font-bold tracking-[0.18em] text-white text-lg">
          MIRAL<span className="text-gold">.</span>
        </span>
        {!compact && (
          <span className="block font-mono2 text-[9px] tracking-[0.5em] text-slate-400 mt-1">GROUP</span>
        )}
      </span>
    </span>
  );
}
